import React from "react";
import { Jumbotron } from "./migration";

const AboutMe = ({ heading, message, link, imgSize, resume }) => {
  const [profilePicUrl, setProfilePicUrl] = React.useState("");
  const [showPic, setShowPic] = React.useState(Boolean(link));

  return (
    <Jumbotron id="aboutme" className="m-0">
      <div className="container row">
        <div className="col-5 d-none d-lg-block align-self-center">
          {showPic && (
            <img
              className="border border-secondary rounded-circle"
              src={link}
              alt="profilepicture"
              width={imgSize}
              height={imgSize}
            />
          )}
        </div>
        <div className={`col-lg-${showPic ? "7" : "12"}`}>
          <h2 className="display-4 mb-5 text-center">{heading}</h2>
          <p className="lead text-center">
            <p>
              I am a BCompSci graduate{" "}
              <a
                href="https://www.uq.edu.au/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                @University of Queensland
              </a>{" "}
              with a strong foundation in cyber security and cryptographic
              algorithms.
            </p>
            <p>
              I'm a full stack developer, and I primarily work with
              <strong> Javascript</strong> and <strong>Typescript</strong> on
              React and NextJS. I have also contributed to numerous Web3
              open-source projects on{" "}
              <a
                href="https://ethereum.org/en/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                Ethereum
              </a>{" "}
              and{" "}
              <a
                href="https://solana.com/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                Solana
              </a>
              .
            </p>

            <p>
              I also do investigative research and write-ups on Web3 related
              projects and industry standards.
            </p>
          </p>
          {resume && (
            <p className="lead text-center">
              <a
                className="btn btn-outline-dark btn-lg"
                href={process.env.PUBLIC_URL + "/#cv"}
                // target="_blank"
                // rel="noreferrer noopener"
                role="button"
                aria-label="Resume/CV"
              >
                My CV
              </a>
            </p>
          )}
        </div>
      </div>
    </Jumbotron>
  );
};

export default AboutMe;
